export default __webpack_public_path__ + "static/media/Tom-Dwan.b270b027.png";